import * as form from '../form';

export const substanceAlcoholOrdered = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Seekers: form.checkboxgroup(xitem.Seekers),
        OtherSeeker: form.text(xitem.OtherSeeker),
        ActionTaken: form.branch(xitem.ActionTaken),
        NoActionTakenExplanation: form.textarea(xitem.NoActionTakenExplanation),
        CounselingDates: form.daterange(xitem.CounselingDates),
        TreatmentProviderName: form.text(xitem.TreatmentProviderName),
        TreatmentProviderNameNotApplicable: form.notapplicable(xitem.TreatmentProviderNameNotApplicable), // PVQ Only
        TreatmentProviderPersonName: form.name(xitem.TreatmentProviderPersonName), // PVQ Only
        TreatmentProviderAddress: form.location(xitem.TreatmentProviderAddress),
        TreatmentProviderAddressNotApplicable: form.notapplicable(xitem.TreatmentProviderAddressNotApplicable), // PVQ Only
        TreatmentProviderTelephone: form.telephone(xitem.TreatmentProviderTelephone),
        TreatmentProviderPhones: form.collection(form.telephoneCollection(xitem.TreatmentProviderPhones)), // PVQ Only
        TreatmentProviderEmails: form.collection(form.emailCollection(xitem.TreatmentProviderEmails)), // PVQ Only
        CompletedTreatment: form.branch(xitem.CompletedTreatment),
        NoCompletedTreatmentExplanation: form.textarea(xitem.NoCompletedTreatmentExplanation),
        OrderedByComments: form.textarea(xitem.OrderedByComments),
        Comments: form.textarea(xitem.Comments),
        CompletedTreatmentComments: form.textarea(xitem.CompletedTreatmentComments),
        NoActionTakenExplanationComments: form.textarea(xitem.NoActionTakenExplanationComments),
        OrderedBy: form.radio(xitem.OrderedBy), // PVQ Only
        OrderedByExplanation: form.textarea(xitem.OrderedByExplanation), // PVQ Only
      },
    };
  });
  return {
    HasBeenOrdered: form.branch(data.HasBeenOrdered),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
